(function () {
  var nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('stuck', window.scrollY > 30);
    }, { passive: true });
  }

  var burger = document.getElementById('burger');
  var drawer = document.getElementById('drawer');
  var close = document.getElementById('drawer-close');

  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }

  if (burger) burger.addEventListener('click', function () { setDrawer(true); });
  if (close) close.addEventListener('click', function () { setDrawer(false); });
  if (drawer) drawer.addEventListener('click', function (e) {
    if (e.target.tagName === 'A') setDrawer(false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { setDrawer(false); setPw(false); }
  });

  var rail = document.getElementById('rail');
  function step(dir) {
    if (!rail) return;
    var t = rail.querySelector('.tile');
    var d = t ? t.getBoundingClientRect().width + 12 : 280;
    rail.scrollBy({ left: d * dir, behavior: 'smooth' });
  }
  var prev = document.getElementById('prev'), next = document.getElementById('next');
  if (prev) prev.addEventListener('click', function () { step(-1); });
  if (next) next.addEventListener('click', function () { step(1); });


  // Hero carousel dots (mobile). Desktop shows all three side by side.
  var track = document.getElementById('hero-track');
  var dots = document.getElementById('hero-dots');
  if (track && dots) {
    var btns = Array.prototype.slice.call(dots.querySelectorAll('button'));
    var sync = function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      btns.forEach(function (b, n) { b.classList.toggle('on', n === i); });
    };
    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(sync);
    }, { passive: true });
    btns.forEach(function (b, n) {
      b.addEventListener('click', function () {
        track.scrollTo({ left: n * track.clientWidth, behavior: 'smooth' });
      });
    });
    sync();
  }

  // Storefront password modal (password page only)
  var pwModal = document.getElementById('pw-modal');
  function setPw(open) {
    if (!pwModal) return;
    pwModal.classList.toggle('open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  var pwOpen = document.getElementById('pw-open'), pwClose = document.getElementById('pw-close');
  if (pwOpen) pwOpen.addEventListener('click', function () { setPw(true); });
  if (pwClose) pwClose.addEventListener('click', function () { setPw(false); });
  if (pwModal && pwModal.dataset.error === 'true') setPw(true);

  // After a successful signup Shopify reloads with ?customer_posted=true —
  // drop the visitor back at the form so they see the confirmation.
  if (window.location.search.indexOf('customer_posted=true') > -1) {
    var el = document.getElementById('signup');
    if (el) el.scrollIntoView();
  } else if (window.location.hash === '#signup') {
    var h = document.getElementById('signup');
    if (h) h.scrollIntoView();
  }
})();
